import {inject} from 'aurelia-framework';
import {IdentityProvider} from 'devtag-aurelia-auth-plugin';

@inject(IdentityProvider)
export class Dashboard {
  constructor(identityProvider) {
    this.loggedInPersonId = identityProvider.getPersonId();
  }
}
